export const toBackendDateFormat = (date: Date | number | string) => {
  const d = new Date(date);
  const utcDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0));
  return utcDate.toISOString();
};
